<template>
  <div>
    <!-- Sandboxed (no scripts, no same-origin) so email HTML can't run code in the app or read its session.
         Links open in a new tab via the injected <base target="_blank">. -->
    <iframe v-if="emailHtml" class="email-frame" sandbox="allow-popups allow-popups-to-escape-sandbox" referrerpolicy="no-referrer" :srcdoc="emailHtml"></iframe>
  </div>
</template>

<script lang="ts">
import MessageServiceV1 from "@/api/Communication/MessageHistory/MessageHistoryService"

import { Options, Vue } from "vue-class-component"
import { useRoute } from "vue-router"

@Options({
  components: {},
})
export default class ViewEmailInBrowserView extends Vue {
  emailHtml = ""
  trackingId = ""
  route = useRoute()
  async mounted() {
    this.trackingId = this.route.params.trackingId as string
    var html = await MessageServiceV1.getMessageHistory(this.trackingId)
    this.emailHtml = typeof html === "string" ? '<base target="_blank">' + html : ""
  }
}
</script>

<style lang="scss">
.email-frame {
  display: block;
  width: 100%;
  height: 100vh;
  border: none;
}
</style>
